"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _Image = _interopRequireDefault(require("../Image"));
var _RouteContext = require("@deosite/lib/RouteContext");
var __jsx = _react["default"].createElement;
var RectangleCardWithLabelBoxInside = function RectangleCardWithLabelBoxInside(props) {
  var link = props.link,
    label = props.label,
    image = props.image,
    promoLabel = props.promoLabel;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(Link, {
    route: link
  }, __jsx(_LinkRaw["default"], {
    title: label
  }, __jsx(_Image["default"], {
    sx: {
      width: "100%",
      height: "100%",
      position: "relative",
      zIndex: 1,
      objectFit: "contain",
      aspectRatio: 1.333
    },
    sizes: "(max-width: 1300px) and (min-width: 1200px) 210px, 420px",
    image: image
  }, __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      bottom: "s8",
      width: "100%",
      textAlign: "center",
      zIndex: 2
    }
  }, label && __jsx(_Box["default"], {
    sx: {
      display: "inline-block",
      bg: "white",
      pt: "s4",
      pb: "s2",
      px: "s6",
      font: "label2",
      maxWidth: "80%",
      color: "main",
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: "main"
    }
  }, __jsx(_Box["default"], {
    sx: {
      color: promoLabel === null || promoLabel === void 0 ? void 0 : promoLabel.labelColor
    },
    as: "span"
  }, promoLabel === null || promoLabel === void 0 ? void 0 : promoLabel.labelText, __jsx(_Box["default"], {
    sx: {
      position: "relative",
      bg: "main",
      width: "2px",
      height: "2px",
      display: promoLabel !== null && promoLabel !== void 0 && promoLabel.labelText ? "inline-block" : "none",
      mx: "s3",
      bottom: "s3"
    },
    as: "i"
  })), label)))));
};
var _default = RectangleCardWithLabelBoxInside;
exports["default"] = _default;